// RecommendedLessonCard.jsx
import React from 'react';
import { 
  ClockIcon,  
  CalendarIcon, 
} from '../common/IconsComponent';

const RecommendedLessonCard = ({ lesson, onAddToCart }) => {
  

  return (
    <div className="border rounded-lg p-2 sm:p-3 md:p-4 relative transition border-gray-200 hover:border-indigo-300 hover:shadow-md flex flex-col sm:flex-row gap-0 sm:gap-3 md:gap-4">
      {/* Tags */}
      {lesson.discount && (
        <span className="absolute -top-1.5 sm:-top-2 right-2 sm:right-3 bg-orange-500 text-white text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full">
          {lesson.discount} הנחה
        </span>
      )}
      {lesson.tag && (
        <span className="absolute -top-1.5 sm:-top-2 left-2 sm:left-3 bg-blue-500 text-white text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full">
          {lesson.tag}
        </span>
      )}
      
      {/* Left column - main content */}
      <div className="flex-1 m-4">
        <h4 className="font-medium text-sm sm:text-base md:text-lg mb-1 sm:mb-1.5 md:mb-2 truncate">
          {lesson.title}
        </h4>
        <div className="text-xs sm:text-sm md:text-base text-gray-600 mb-1.5 sm:mb-2 md:mb-3 truncate">
          מרצה: {lesson.instructor}
        </div>
        
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4 mb-1.5 sm:mb-2 md:mb-3">
          <div className="flex items-center text-xs sm:text-sm md:text-base text-gray-600">
            <CalendarIcon className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 ml-0.5 sm:ml-1 text-indigo-600" />
            <span>{lesson.date}</span>
          </div>
          
          <div className="flex items-center text-xs sm:text-sm md:text-base text-gray-600">
            <ClockIcon className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 ml-0.5 sm:ml-1 text-indigo-600" />
            <span>{lesson.time}</span>
          </div>
        </div>
      </div>
      
      {/* Action area - different alignment on mobile vs desktop */}
      <div className="w-full flex sm:flex-col sm:items-end justify-between sm:justify-start gap-4 sm:gap-8 mt-2 mb-3 sm:m-4 sm:min-w-fit sm:w-24 md:w-32 px-4 sm:px-0 sm:mr-3 md:mr-4">
        <div className="flex flex-col items-start sm:items-end">
          <span className="text-sm sm:text-base md:text-lg font-bold text-indigo-700">
            ₪{lesson.price}
          </span>
          {lesson.originalPrice && (
            <span className="text-[10px] sm:text-xs md:text-sm text-gray-400 line-through">
              ₪{lesson.originalPrice}
            </span>
          )}
        </div>
        <button
          className="px-2 md:px-3 py-0.5 sm:py-1 md:py-2 bg-gradient-to-r from-green-400 to-green-300 text-green-800 text-xs sm:text-sm rounded-xl border border-green-200 shadow-sm hover:shadow-md hover:from-green-500 hover:to-green-400 hover:text-green-900 whitespace-nowrap hover:font-bold transition-all duration-200 flex items-center gap-1"
          onClick={()=>onAddToCart(lesson.id)}
        >
          הוסף לסל <span className="transform transition-transform hover:scale-110">+</span>
        </button>
        
      </div>
    </div>
  );
};

export default RecommendedLessonCard;